export const META_PIXEL_ID = '1080811751284276'

type FbqArgs = unknown[]

interface FbqFunction {
  (...args: FbqArgs): void
  callMethod?: (...args: FbqArgs) => void
  queue?: FbqArgs[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: FbqFunction
    _fbq?: FbqFunction
  }
}

let initialized = false

function loadPixelScript(): void {
  if (window.fbq) return

  const fbq: FbqFunction = function (...args: FbqArgs) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  }

  fbq.queue = []
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

/** Loads the Meta Pixel and fires the PageView event. Safe to call more than once. */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || initialized) return
  initialized = true

  loadPixelScript()
  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires an arbitrary standard Meta Pixel event. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, params)
}

/** Fires AddToCart when the visitor heads to Shopify checkout. */
export function trackAddToCart(): void {
  trackPixelEvent('AddToCart', {
    content_name: 'The Second-Half Performance Bundle',
    content_ids: ['52246321594658'],
    content_type: 'product',
    value: 27,
    currency: 'USD',
  })
}
